import { useState } from 'react';
import { faqs } from '@/mocks/homeData';

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-secondary-900">
              <i className="ri-questionnaire-line" /> 常见问答
            </span>
            <h2 className="mt-2 text-2xl font-extrabold text-foreground-950 md:text-4xl">你可能想问</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              关于 91免费精选合集与内容包的常见疑问，先看这里通常就够了。没覆盖到的，往素材库与话题墙里再翻翻。
            </p>
          </div>

          <div className="flex flex-col gap-3 lg:col-span-3">
            {faqs.map((faq, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={faq.q}
                  className={`overflow-hidden rounded-xl border transition-colors ${
                    isOpen ? 'border-primary-300 bg-background-100' : 'border-background-200 bg-background-50'
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : i)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="text-sm font-semibold text-foreground-950 md:text-base">{faq.q}</span>
                    <i
                      className={`shrink-0 text-lg text-primary-600 transition-transform ${
                        isOpen ? 'rotate-45' : ''
                      } ri-add-line`}
                    />
                  </button>
                  {isOpen && (
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}